/**
 * @generated SignedSource<<17fd23a8087769f68dd0d5cd8675f7c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueSearchInputProvider_jiraView$data = {
  readonly jql?: string | null | undefined;
  readonly " $fragmentType": "IssueSearchInputProvider_jiraView";
};
export type IssueSearchInputProvider_jiraView$key = {
  readonly " $data"?: IssueSearchInputProvider_jiraView$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSearchInputProvider_jiraView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueSearchInputProvider_jiraView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jql"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "843375146a1d31e603cfec76c2a29acc";

export default node;
